<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Procedimento administrativo"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :disabled="!!item"
                        :repository="repositories.procedimento"
                        :request-query-string-params="requestQueryStringParams.procedimento"
                        :search-fields="fields.procedimento"
                        :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                        :validations="validations.procedimento"
                        @select="model.cid = null"
                        label="Procedimento"
                        v-model="model.procedimento"
                    />
                </rkm-col>

                <rkm-col cols="5">
                    <rkm-form-input-autocomplete
                        :disabled="!model.procedimento"
                        :repository="repositories.cid"
                        :request-query-string-params="requestQueryStringParams.cid"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${formatCid(item.codigo)} - ${item.nome}`"
                        :validations="validations.cid"
                        label="CID"
                        v-model="model.cid"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import {formats, object, repository} from '@/mixins'

export default {
    computed: {
        requestQueryStringParams() {
            return {
                procedimento: {
                    cbo_lotacao_atual: true,
                    paciente_id: this.data.additionals.paciente.id,
                    competencia_id: this.data.additionals.isRetroativo ? this.data.additionals.agendamentoCompetenciaId : null,
                },
                cid: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                    ? {
                        principal: true,
                        procedimento_id: this.model.procedimento.id,
                    }
                    : {}
            }
        },
        validations() {
            return {
                procedimento: {required: true},
                cid: {required: this.model.procedimento && !!this.model.procedimento.hasCidPrincipal},
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 3,
                },
                observacao: {max: 500},
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        enums: {procedimento},
        fields: {
            procedimento: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
        },
        item: null,
        model: {
            procedimento: null,
            cid: null,
            quantidade: 1,
            observacao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                procedimento: this.item.procedimento,
                cid: this.item.cid,
                quantidade: this.item.quantidade,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.data.model.procedimentosAdministrativos.push({
                procedimento: {
                    id: this.model.procedimento.id,
                    codigo: this.model.procedimento.codigo,
                    nome: this.model.procedimento.nome,
                    hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                    hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                },
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                automatico: false,
                quantidade: this.model.quantidade,
                observacao: this.model.observacao,
            })
        },
        update() {
            Object.assign(this.item, {
                procedimento: {
                    id: this.model.procedimento.id,
                    codigo: this.model.procedimento.codigo,
                    nome: this.model.procedimento.nome,
                    hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                    hasCidPrincipal: this.model.procedimento.hasCidPrincipal,
                },
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                automatico: false,
                quantidade: this.model.quantidade,
                observacao: this.model.observacao,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (!this.item && this.data.model.procedimentosAdministrativos.find(procedimentoAdministrativo => procedimentoAdministrativo.procedimento.id === this.model.procedimento.id)) {
                        this.showValidationNotification('O procedimento administrativo já foi incluído.')
                        return
                    }

                    if (this.model.procedimento.codigo === this.enums.procedimento.ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA) {

                        let mensagemDemanda = '';

                        if(this.data.additionals.isDemandaEspontanea){

                            mensagemDemanda = `Este procedimento é registrado automaticamente pelo sistema, evitando inconsistências no registro de atendimentos de demanda espontânea.`
                        }else{

                            mensagemDemanda = `Não pode ser preenchido com o procedimento <strong>03.01.04.007-9 - Escuta inicial / orientação (acolhimento a demanda espontânea)</strong>.
                            Esta informação é registrada automaticamente pelo sistema para atendimentos de Demanda Espontânea.`

                        }

                        this.showValidationNotification(mensagemDemanda)
                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.procedimento = null
            this.model.cid = null
            this.model.quantidade = 1
            this.model.observacao = null
        },
    },
    mixins: [formats, object, repository],
    props: {
        data: {required: true, type: Object},
    },
}
</script>